import {
  getSubscriptionContract as publicGetSubscriptionContract,
  querySubscriptionContracts as publicQuerySubscriptionContracts,
  typedQuerySubscriptionContracts as publicTypedQuerySubscriptionContracts,
} from './ecom-subscription-contracts-v1-subscription-contract-subscription-contracts.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  SubscriptionContractQuery,
  SubscriptionContractsQueryBuilder,
  typedQuerySubscriptionContracts as universalTypedQuerySubscriptionContracts,
} from './ecom-subscription-contracts-v1-subscription-contract-subscription-contracts.universal.js';
import { onSubscriptionContractCreated as publicOnSubscriptionContractCreated } from './ecom-subscription-contracts-v1-subscription-contract-subscription-contracts.public.js';
import { onSubscriptionContractDeleted as publicOnSubscriptionContractDeleted } from './ecom-subscription-contracts-v1-subscription-contract-subscription-contracts.public.js';
import { onSubscriptionContractUpdated as publicOnSubscriptionContractUpdated } from './ecom-subscription-contracts-v1-subscription-contract-subscription-contracts.public.js';

function customQuerySubscriptionContracts(httpClient: HttpClient) {
  const router = createQueryOverloadRouter({
    builderQueryFunction: () => publicQuerySubscriptionContracts(httpClient)(),
    typedQueryFunction: (query: SubscriptionContractQuery) =>
      publicTypedQuerySubscriptionContracts(httpClient)(query),
    hasOptionsParameter: false,
  });

  function overloadedQuery(): SubscriptionContractsQueryBuilder;
  function overloadedQuery(
    query: SubscriptionContractQuery
  ): ReturnType<typeof universalTypedQuerySubscriptionContracts>;
  function overloadedQuery(query?: SubscriptionContractQuery): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const getSubscriptionContract: MaybeContext<
  BuildRESTFunction<typeof publicGetSubscriptionContract> &
    typeof publicGetSubscriptionContract
> = /*#__PURE__*/ createRESTModule(publicGetSubscriptionContract);
export const querySubscriptionContracts: MaybeContext<
  BuildRESTFunction<typeof customQuerySubscriptionContracts> &
    typeof customQuerySubscriptionContracts
> = /*#__PURE__*/ createRESTModule(customQuerySubscriptionContracts);
/** */
export const onSubscriptionContractCreated: BuildEventDefinition<
  typeof publicOnSubscriptionContractCreated
> &
  typeof publicOnSubscriptionContractCreated = createEventModule(
  publicOnSubscriptionContractCreated
);
/** */
export const onSubscriptionContractDeleted: BuildEventDefinition<
  typeof publicOnSubscriptionContractDeleted
> &
  typeof publicOnSubscriptionContractDeleted = createEventModule(
  publicOnSubscriptionContractDeleted
);
/** */
export const onSubscriptionContractUpdated: BuildEventDefinition<
  typeof publicOnSubscriptionContractUpdated
> &
  typeof publicOnSubscriptionContractUpdated = createEventModule(
  publicOnSubscriptionContractUpdated
);

export {
  SubscriptionFrequency,
  SubscriptionSettingsProductPeriodAlignment,
  DescriptionLineType,
  DimensionsUnit,
  ItemTypePreset,
  PaymentOptionType,
  JurisdictionType,
  V2SubscriptionFrequency,
  ProductPeriodAlignment,
  AdjustmentType,
  TaxableAddressType,
  MeasurementUnit,
  WeightUnit,
  ChargeType,
  VatType,
  PickupMethod,
  DiscountType,
  DiscountReason,
  ChannelType,
  AdditionalFeeSource,
  SpecificItemsCouponBehavior,
  LineItemQuantityChangeType,
  ActivityType,
  ActionInitiator,
  ChangeType,
  SortOrder,
  WebhookIdentityType,
} from './ecom-subscription-contracts-v1-subscription-contract-subscription-contracts.universal.js';
export {
  SubscriptionContract,
  V1SubscriptionDescription,
  V1SubscriptionSettings,
  V1FreeTrialPeriod,
  V1BillingSettings,
  OrderLineItem,
  ProductName,
  CatalogReference,
  Price,
  DescriptionLine,
  DescriptionLineValueOneOf,
  DescriptionLineDescriptionLineValueOneOf,
  DescriptionLineName,
  PlainTextValue,
  Color,
  FocalPoint,
  PhysicalProperties,
  Dimensions,
  ItemType,
  ItemTypeItemTypeDataOneOf,
  RestockLocation,
  ItemTaxFullDetails,
  LineItemTaxInfo,
  LineItemTaxBreakdown,
  DigitalFile,
  SubscriptionInfo,
  SubscriptionTitle,
  SubscriptionDescription,
  SubscriptionSettings,
  FreeTrialPeriod,
  BillingSettings,
  BillingAdjustment,
  BillingAdjustmentPriceSummary,
  PriceDescription,
  LocationAndQuantity,
  TaxableAddress,
  TaxableAddressTaxableAddressDataOneOf,
  DecimalQuantity,
  DecimalQuantityUnitOneOf,
  TranslatableString,
  ExtendedFields,
  ModifierGroup,
  ItemModifier,
  BuyerInfo,
  BuyerInfoIdOneOf,
  CurrencyConversionDetails,
  PriceSummary,
  PlatformFeeSummary,
  PlatformFee,
  AddressWithContact,
  Address,
  StreetAddress,
  AddressLocation,
  FullAddressContactDetails,
  VatId,
  ShippingInformation,
  DeliveryLogistics,
  DeliveryLogisticsAddressOneOf,
  PickupDetails,
  PickupAddress,
  DeliveryTimeSlot,
  ShippingPrice,
  ShippingRegion,
  OrderTaxInfo,
  OrderTaxBreakdown,
  AppliedDiscount,
  AppliedDiscountDiscountSourceOneOf,
  Coupon,
  MerchantDiscount,
  MerchantDiscountMerchantDiscountReasonOneOf,
  DiscountRule,
  DiscountRuleName,
  LineItemDiscount,
  ItemCombination,
  ItemCombinationLineItem,
  ChannelInfo,
  CustomField,
  V1SubscriptionTitle,
  AdditionalFee,
  Location,
  SubscriptionContractSettings,
  SubscriptionContractActivity,
  SubscriptionContractActivityTargetOneOf,
  SubscriptionContractActivityContentOneOf,
  ContractTarget,
  ActivityAuthor,
  ActivityAuthorValueOneOf,
  ChangesAppliedActivity,
  ChangesAppliedActivityTargetOneOf,
  ContractChange,
  ContractChangeValueOneOf,
  LineItemChanges,
  LineItemQuantityChange,
  ManagedLineItem,
  ManagedDiscount,
  TranslatedValue,
  ManagedAdditionalFee,
  TotalPriceChange,
  SubscriptionContractCanceled,
  SubscriptionContractExpired,
  SubscriptionContractChangesCommitted,
  SubscriptionContractDiffs,
  LineItemDelta,
  AppliedDiscountDelta,
  AppliedDiscountDeltaDeltaDetailsOneOf,
  AdditionalFeeDelta,
  AdditionalFeeDeltaDeltaDetailsOneOf,
  CreateSubscriptionContractRequest,
  CreateSubscriptionContractResponse,
  GetSubscriptionContractRequest,
  GetSubscriptionContractResponse,
  UpdateSubscriptionContractRequest,
  UpdateSubscriptionContractResponse,
  QuerySubscriptionContractsRequest,
  CursorQuery,
  CursorQueryPagingMethodOneOf,
  Sorting,
  CursorPaging,
  QuerySubscriptionContractsResponse,
  CursorPagingMetadata,
  Cursors,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  Empty,
  BulkCreateSubscriptionContractsRequest,
  BulkCreateSubscriptionContractsResponse,
  BulkSubscriptionContractResult,
  ItemMetadata,
  ApplicationError,
  BulkActionMetadata,
  BulkUpdateSubscriptionContractsRequest,
  MaskedSubscriptionContract,
  BulkUpdateSubscriptionContractsResponse,
  CommitSubscriptionContractChangesRequest,
  SubscriptionCommitSettings,
  CommitSubscriptionContractChangesResponse,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  SubscriptionContractCreatedEnvelope,
  SubscriptionContractDeletedEnvelope,
  SubscriptionContractUpdatedEnvelope,
  SubscriptionContractsQueryResult,
  SubscriptionContractsQueryBuilder,
  SubscriptionContractQuerySpec,
} from './ecom-subscription-contracts-v1-subscription-contract-subscription-contracts.universal.js';
export { utils } from './ecom-subscription-contracts-v1-subscription-contract-subscription-contracts.universal.js';
export {
  SubscriptionFrequencyWithLiterals,
  SubscriptionSettingsProductPeriodAlignmentWithLiterals,
  DescriptionLineTypeWithLiterals,
  DimensionsUnitWithLiterals,
  ItemTypePresetWithLiterals,
  PaymentOptionTypeWithLiterals,
  JurisdictionTypeWithLiterals,
  V2SubscriptionFrequencyWithLiterals,
  ProductPeriodAlignmentWithLiterals,
  AdjustmentTypeWithLiterals,
  TaxableAddressTypeWithLiterals,
  MeasurementUnitWithLiterals,
  WeightUnitWithLiterals,
  ChargeTypeWithLiterals,
  VatTypeWithLiterals,
  PickupMethodWithLiterals,
  DiscountTypeWithLiterals,
  DiscountReasonWithLiterals,
  ChannelTypeWithLiterals,
  AdditionalFeeSourceWithLiterals,
  SpecificItemsCouponBehaviorWithLiterals,
  LineItemQuantityChangeTypeWithLiterals,
  ActivityTypeWithLiterals,
  ActionInitiatorWithLiterals,
  ChangeTypeWithLiterals,
  SortOrderWithLiterals,
  WebhookIdentityTypeWithLiterals,
  CommonQueryWithEntityContext,
  SubscriptionContractQuery,
} from './ecom-subscription-contracts-v1-subscription-contract-subscription-contracts.universal.js';
